<template>
  <div class="dashboard-promo-banner-heroes" :class="{ open: isOpen }">
    <a :href="bannerLink" class="banner--content">
      <div class="banner-content-wrap">
        <div class="banner--content__left">
          <div class="promo">
            <div class="promo-intro">
              {{ $gettext('Welcome') }} <strong>{{ userName }}</strong>!
            </div> 
            <div v-html="$gettext('You signed up for Gekko using a discount link from a Gekko Hero. This means you can use a Basic account unlimited for free. But if you decide to upgrade to a Premium account, you will get a <span class=\'banner-price-tag\'><strong>37,5% discount</strong></span> from your Gekko Hero. Do note: this is a time limited offer and you need to decide to use this discount code before the timer runs out.')" />
          </div>
        </div>
        <div class="banner--content__right">
          <div class="flip-count">
            <span class="flip-title">{{ $gettext('Discount available until') }}</span>
            <FlipCount :time-until="promoEnds" />
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import FlipCount from "@/components/dashboard/ui/FlipCount"
import moment from 'moment';
export default {
  name: "PromoBannerHeroes",
  components: {
    FlipCount
  },
  props: {
    promoData: {
      type: Object,
      default: () => {}
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpen: false,
      promoEnds: null,
      bannerType: null,
      debug: false
    }
  },
  computed: {
    ...mapGetters ({ 
      preferredLanguage: 'main/getPreferredLanguage'
    }),
    bannerLink () {
      return '/subscriptions/manage/?selected=year'
    }
  },
  created () {
    if (this.promoData) {
      let dateformat = (this.preferredLanguage === 'en') ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
      this.promoEnds = moment(this.promoData.end_time).format(dateformat)
    }
  },
  mounted () {
    setTimeout(() => {
      this.isOpen = true
    }, 1000)
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
.dashboard-promo-banner {
  .banner-price-tag {
    position: relative;
    display: inline;
    &:before {
      content: '';
      position: absolute;
      bottom: -3px;
      left: 0;
      width: 0;
      height: 4px;
      background: white;
      transition: width 1s ease-in-out;
      transition-delay: 1s;
    }
  }
  &.open {
    .banner-price-tag {
      &:before {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
  .dashboard-promo-banner-heroes {
    cursor: pointer;
    display: flex;
    align-items: center;
    background: linear-gradient(103deg, #28ac8a, #1e8369);
    height: 0px;
    // overflow: hidden;
    overflow: visible;
    transition: height 0.8s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    margin-bottom: 0.5rem;
    border-radius: 12px;
    margin-left: 1rem;
    margin-right: 1rem;

    .banner-price-tag {
      &:before {
        bottom: -2px;
        height: 2px;
      }
    }

    .banner--content {
      &:hover {
        text-decoration: none;
      }
      display: flex; 
      padding: 0.75rem;
      font-weight: 900; 
      flex-direction: column; 
      justify-content: center; 
      width: 100%; 
      // max-width: 80rem; 
      height: 100%; 

      @media (min-width: 640px) { 
        padding-left: 1.5rem;
        padding-right: 1.5rem; 
      }

      @media (min-width: 1024px) { 
        padding-left: 2rem;
        padding-right: 2rem; 
      }

      transition: all 0.5s cubic-bezier(0.750, 0.020, 0.190, 1.290);
      opacity: 0;
      transform: scale(0.9);
      .banner-content-wrap {
        display: flex; 
        flex-wrap: wrap; 
        justify-content: space-between; 
        align-items: center; 
      }
      &__left {
        display: flex; 
        flex-direction: column; 
        align-items: center; 
        justify-content: space-evenly;
        width: 100%; 

        @media (min-width: 640px) { 
          flex-direction: row; 
          flex: 1 1 0%; 
          width: 0; 
        }

        .promo {
          display: block; 
          color: #ffffff; 
          text-align: center; 

          font-size: 17px;
          line-height: 1.4;
          text-align: left;
          font-weight: 100;
          padding: 1rem;
          padding-right: 2rem;

          .promo-intro {
            display: block;
            margin-bottom: 1rem;
          }
          .discount-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            border: 1px dashed white;
            box-shadow: 0 0 0 2px #C42F52, rgba(0,0,0,0.2) 0px 15px 35px 0px, rgba(0,0,0,0.12) 0px 5px 15px 0px;
            background: #C42F52;
            color: white;
            border-radius: 8px;
            padding: 0 0.5rem;
            margin: 0 10px;
          }
        }
        .limited-time {
          font-size: 1rem;
          text-transform: uppercase;
          color: white;
        }
      }
      &__right {
        display: flex; 
        margin-top: 0.25rem; 
        flex-shrink: 0; 
        order: 3; 
        justify-content: center; 
        width: 100%; 

        @media (min-width: 640px) { 
          margin-top: 0; 
          margin-right: 3rem; 
          order: 2; 
          width: auto; 
        }
        .pre-deadline {
          display: flex; 
          color: #ffffff; 
          font-size: 1.125rem;
          line-height: 1.75rem; 
          text-transform: uppercase; 
        }
        .flip-count {
          display: flex; 
          color: #333; 
          font-size: 0.875rem;
          line-height: 1.25rem; 
          text-align: center; 
          text-transform: uppercase; 

          padding: 1rem;
          background: white;
          border-radius: 12px;

          .flip-title {
            font-size: 18px;
          }
          .promo-timer {
            color: #333; 
          }

          @media (min-width: 640px) { 
            flex-direction: column; 
          }
          .flip-title {
            margin-bottom: 0.5rem; 
          }
        }
      }
    }
    &.open {
      height: auto;
      .banner--content {
        opacity: 1;
        transform: scale(1);
        transition-delay: 0.5s;
      }
    }
    @media (min-width: 640px) {
      &.open {
        height: auto;
      }
    }
    
    

  }
</style>
